import { handleActions } from 'redux-actions';

import * as actions from '../actions';

const InitialState = null;

export const onboardingStepsReducer = handleActions(
  {
    [actions.setOnboardingSteps]: (state, { payload: onboardingSteps }) => onboardingSteps,
  },
  InitialState
);
